import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class AnnouncementCypressAttribute extends CypressAttribute {
  static views = {
    ANNOUNCEMENT_OVERFLOW_INDICATOR:
      'AnnouncementCypressAttribute:views:ANNOUNCEMENT_OVERFLOW_INDICATOR',
    ANNOUNCEMENT_DATE_GROUP_LIST_ITEM:
      'AnnouncementCypressAttribute:views:ANNOUNCEMENT_DATE_GROUP_LIST_ITEM',
    ANNOUNCEMENT_RELEASE_GROUP_ITEM:
      'AnnouncementCypressAttribute:views:ANNOUNCEMENT_RELEASE_GROUP_ITEM',
    ANNOUNCEMENT_RELEASE_DATE: 'AnnouncementCypressAttribute:views:ANNOUNCEMENT_RELEASE_DATE',
    ANNOUNCEMENT_TITLE: 'AnnouncementCypressAttribute:views:ANNOUNCEMENT_TITLE',
    ANNOUNCEMENT_DESCRIPTION: 'AnnouncementCypressAttribute:views:ANNOUNCEMENT_DESCRIPTION',
    ANNOUNCEMENT_CONTENT_SOURCE: 'AnnouncementCypressAttribute:views:ANNOUNCEMENT_CONTENT_SOURCE',
    ANNOUNCEMENT_CONTENT_CONTAINER:
      'AnnouncementCypressAttribute:views:ANNOUNCEMENT_CONTENT_CONTAINER'
  };

  static buttons = {
    ANNOUNCEMENT_CLOSE_BUTTON: 'AnnouncementCypressAttribute:views:ANNOUNCEMENT_CLOSE_BUTTON'
  };
}
